import { useEffect, useRef } from "react";
const EVENTS = ["mousemove", "keydown", "click", "touchstart"];
export const useInactivityTimeout = (onTimeout, delay = 600000) => {
  const timerRef = useRef(null);
  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onTimeout();
    }, delay);
  };
  useEffect(() => {
    resetTimer();
    EVENTS.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      EVENTS.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);
};
